<div class="container" *ngIf="timeline?.length > 0">
  <div class="row">
    <div class="col-md-8">
      <div class="card p-3">
  <div class="card-header">
    <i class="fas fa-map-marker-alt"></i>
    <h3>Delivery Details</h3>
  </div>
  <div class="d-flex">
      <div class="icon-line">
      <span class="circle orange"></span>
      <span class="line"  style="height: 100%;"></span>
      <span class="square green"></span>
    </div>
    <div>
        <!-- Pickup Address -->
  <div class="delivery-section">
    <div class="section-content">
      <h4>Pickup Address</h4>
      <p>Counfreedise Buymore Bangalore</p>
      <p>Bangalore, Karnataka, IN, 562123</p>
    </div>
  </div>

  <!-- Seller Details -->
  <div class="seller-details mt-2">
    <h4>Seller Details</h4>
    <p>COUNFREEDISE EXPRESS</p>
  </div>

  <!-- Delivery Address -->
  <div class="delivery-section">
    <!-- <div class="icon-line">
      <span class="square green"></span>
    </div> -->
    <div class="section-content mt-2">
      <h4>Delivery Address</h4>
      <p>{{this.fullData[0].delivery_state}} {{this.fullData[0].delivery_pincode}}</p>
    </div>
  </div>
    </div>
  </div>

 



</div>
<div class="card payment-card">
  <div class="card-header d-flex align-items-center">
    <img src="assets/images/money11.png" alt="Payment" class="icon me-2">
    <h5 class="mb-0">Payment Details</h5>
  </div>

  <div class="card-body">
    <div class="row mb-3">
      <div class="col-6 d-flex align-items-center">
        <img src="assets/images/money11.png" alt="Cash" class="icon me-2">
        <span style="font-weight: 600;">{{this.fullData[0].payment_mode}}</span>
      </div>
      <div class="col-6 text-end">
        <strong>₹ {{this.fullData[0].invoice_amount}}</strong>
      </div>
    </div>
    <div class="row mb-3" *ngIf="fullData[0].payment_mode === 'COD'">
      <div class="col-6 d-flex align-items-center">
        <img src="assets/images/money11.png" alt="Cash" class="icon me-2">
        <span style="font-weight: 600;">Collectable Amount</span>
      </div>
      <div class="col-6 text-end">
        <strong>₹ {{this.fullData[0].collectable_amount}}</strong>
      </div>
    </div>
    <!-- <hr> -->
    <!-- <div class="text-end">
      <strong>Grand Total</strong>
      <div><strong style="font-size: 18px;">₹ {{this.fullData[0].invoice_amount}}</strong></div>
    </div> -->
  </div>
</div>



    </div>
    <div class="card p-2 col-md-3">
  <div class="d-flex align-items-center mb-2">
    <img src="assets/images/list1.png">
    <h4 class="ms-3">Shipment Tracker</h4>
  </div>
   <div class="mt-2 d-flex justify-content-between mt-3 mb-3" style="font-weight: 600;">
      <p>AWB :</p>
      <p>{{this.fullData[0].awb}}</p>
    </div>
  <div class="timeline-container">
  <div *ngFor="let item of limitedTimeline; let i = index" class="timeline-item">
    <div class="timeline-icon">{{ item.icon }}</div>
    <div class="timeline-content">
      <h4>{{ item.status }}</h4>
      <p *ngIf="item.date">{{ item.date }}</p>
      <p *ngIf="item.subtext" class="subtext">{{ item.subtext }}</p>
      <p *ngIf="item.delayed" class="delayed">
        Estimated date: {{ item.estimatedDate }} <span>(delayed)</span>
      </p>
    </div>
    <div *ngIf="i < timeline.length - 1" class="timeline-line"></div>
   

  </div>
   <div *ngIf="timeline.length > 4">
    <div  style="color: blue; cursor: pointer;" (click)="open(updateshipment)">More Info</div>
  </div>
</div>

</div>

  </div>

</div>
<!-- <div class="timeline-container">
  <div *ngFor="let item of limitedTimeline; let i = index" class="timeline-item">
    <div class="timeline-icon">{{ item.icon }}</div>
    <div class="timeline-content">
      <h4>{{ item.status }}</h4>
      <p *ngIf="item.date">{{ item.date }}</p>
      <p *ngIf="item.subtext" class="subtext">{{ item.subtext }}</p>
      <p *ngIf="item.delayed" class="delayed">
        Estimated date: {{ item.estimatedDate }} <span>(delayed)</span>
      </p>
    </div>
  </div> -->

  <!-- "More Info" Button -->
  <!-- <div *ngIf="timeline.length > 4" class="more-info">
    <button (click)="open(updateshipment)">More Info</button>
  </div> -->
<!-- </div> -->

<ng-template #updateshipment let-modal>
  <div class="modal-header">
    <h3>All Timeline Records</h3>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body scrollable-modal-body">
    <div class="timeline-container full">
      <div *ngFor="let item of timeline; let i = index" class="timeline-item">
        <div class="timeline-icon">{{ item.icon }}</div>
        <div class="timeline-content">
          <h4>{{ item.status }}</h4>
          <p *ngIf="item.date">{{ item.date }}</p>
          <p *ngIf="item.subtext" class="subtext">{{ item.subtext }}</p>
          <p *ngIf="item.delayed" class="delayed">
            Estimated date: {{ item.estimatedDate }} <span>(delayed)</span>
          </p>
        </div>
        <div *ngIf="i < timeline.length - 1" class="timeline-line"></div>
      </div>
    </div>
    </div>
  

   <ng-container *ngIf="showOverlay" id="overlay-container">
    <app-spinner [overlay]="true" id="loader"></app-spinner>
</ng-container>
</ng-template>

<!-- Modal -->
<!-- <div class="modal-backdrop">
  <div class="modal">
    <h3>All Timeline Records</h3>
    <div class="timeline-container full">
      <div *ngFor="let item of timeline; let i = index" class="timeline-item">
        <div class="timeline-icon">{{ item.icon }}</div>
        <div class="timeline-content">
          <h4>{{ item.status }}</h4>
          <p *ngIf="item.date">{{ item.date }}</p>
          <p *ngIf="item.subtext" class="subtext">{{ item.subtext }}</p>
          <p *ngIf="item.delayed" class="delayed">
            Estimated date: {{ item.estimatedDate }} <span>(delayed)</span>
          </p>
        </div>
        <div *ngIf="i < timeline.length - 1" class="timeline-line"></div>
      </div>
    </div>
  </div>
</div> -->
<ng-container *ngIf="showOverlay" id="overlay-container">
    <app-spinner [overlay]="true" id="loader"></app-spinner>
</ng-container>
